import * as echarts from 'echarts/dist/echarts.esm.min.js';

if($("#disk-chart1").length > 0){
    var use = parseInt($("#disk-chart1").data("use"));
    var total = parseInt($("#disk-chart1").data("total"));
    var notuse = total - use;

    var chartDom = document.getElementById('disk-chart1');
    var myChart = echarts.init(chartDom);


    window.onload = function(){
        myChart.resize();
    }
    window.onresize = function(){
        myChart.resize();
    }
        
    var option;

    option = {
        color: [
            '#28B3D2',
            '#e9ecef'
        ],
        tooltip: {
            trigger: 'item',
            formatter: '{b} : {c}G ({d}%)'
        },
        legend: {
            orient: 'vertical',
            left: 'left'
        },
        series: [
        {
            name: '空間使用率',
            type: 'pie',
            radius: '90%',
            data: [
                { value: use, name: '已使用' },
                { value: notuse, name: '未使用' }
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
        ]
    };

    option && myChart.setOption(option);

}
